<template>
    <modal :show.sync="open" headerClasses="justify-content-center">
        <h5 slot="header" class="title title-up modal-product-title">{{ product.name }}</h5>
        <div class="d-flex justify-content-center align-items-center">
          <p class="text-dark font-weight-bold">{{ product?.description }}</p>
        </div>
        <div class="text-dark">
          <div v-if="product?.category?.name === 'module'">
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Tensão de circuito aberto</p>
                <p class="p-0 m-0">{{ product?.module_configs?.open_circuit_voltage }}V</p>
              </div>
              <div>
                <p class="p-0 m-0">Corrente de curto circuito</p>
                <p class="p-0 m-0">{{ product?.module_configs?.short_circuit_current }}A</p>
              </div>
              <div>
                <p class="p-0 m-0">Potência nominal</p>
                <p class="p-0 m-0">{{ product?.module_configs?.nominal_power }}W</p>
              </div>
            </div>
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Coeficiente ISC</p>
                <p class="p-0 m-0">{{ product?.module_configs?.coefficient_isc }}%/°C</p>
              </div>
              <div>
                <p class="p-0 m-0">Coeficiente VOC</p>
                <p class="p-0 m-0">{{ product?.module_configs?.short_circuit_current }}%/°C</p>
              </div>
              <div>
                <p class="p-0 m-0">Coeficiente PMAX</p>
                <p class="p-0 m-0">{{ product?.module_configs?.coefficient_pmax }}%/°C</p>
              </div>
            </div>
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Eficiência</p>
                <p class="p-0 m-0">{{ product?.module_configs?.efficiency }}%</p>
              </div>
              <div>
                <p class="p-0 m-0">Temperatura nominal</p>
                <p class="p-0 m-0">{{ product?.module_configs?.nominal_temperature }}°C</p>
              </div>
              <div>
                <p class="p-0 m-0">Tipo de célula</p>
                <p class="p-0 m-0">{{ product?.module_configs?.cell_type }}</p>
              </div>
            </div>
          </div>
          <div v-if="product?.category?.name === 'inverter'">
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Máx. potência saída</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.max_output_power }}W</p>
              </div>
              <div>
                <p class="p-0 m-0">Máx. overload</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.max_overload }}%</p>
              </div>
              <div>
                <p class="p-0 m-0">Mín. overload</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.min_overload }}%</p>
              </div>
            </div>
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Máx. tensão por mppt</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.max_voltage_mppt }}V</p>
              </div>
              <div>
                <p class="p-0 m-0">Mín. tensão por mppt</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.min_voltage_mppt }}V</p>
              </div>
              <div>
                <p class="p-0 m-0">Núm. de mppt</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.number_of_mppts }}</p>
              </div>
            </div>
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Máx. corrente por mppt</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.max_input_current_mppt }}</p>
              </div>
              <div>
                <p class="p-0 m-0">Núm. de entradas por mppt</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.number_of_inputs_per_mppt }}</p>
              </div>
              <div>
                <p class="p-0 m-0">Tensão nominal de entrada</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.nominal_input_voltage }}V</p>
              </div>
            </div>
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Feed-in tensão de entrada</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.feed_in_voltage }}V</p>
              </div>
              <div>
                <p class="p-0 m-0">Máx. tensão de entrada</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.max_input_voltage }}V</p>
              </div>
              <div>
                <p class="p-0 m-0">Mín. tensão de entrada</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.min_input_voltage }}V</p>
              </div>
            </div>
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Tensão nominal de saída</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.output_voltage }}V</p>
              </div>
              <div>
                <p class="p-0 m-0">Fase</p>
                <p class="p-0 m-0">{{ product?.inverter_configs?.phase }}</p>
              </div>
            </div>
          </div>
          <div v-if="product?.product_dimensions?.length">
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Largura</p>
                <p class="p-0 m-0">{{ product?.product_dimensions?.width }} cm</p>
              </div>
              <div>
                <p class="p-0 m-0">Comprimento</p>
                <p class="p-0 m-0">{{ product?.product_dimensions?.length }} cm</p>
              </div>
              <div>
                <p class="p-0 m-0">Profundidade </p>
                <p class="p-0 m-0">{{ product?.product_dimensions?.thickness }} cm</p>
              </div>
            </div>
            <div class="modal-content-flex-row">
              <div>
                <p class="p-0 m-0">Peso </p>
                <p class="p-0 m-0">{{ product?.product_dimensions?.weight }} kg</p>
              </div>
              <div>
                <p class="p-0 m-0">Volume </p>
                <p class="p-0 m-0">{{ product?.product_dimensions?.volume }} m<sup>3</sup></p>
              </div>
            </div>
          </div>
          <div v-if="product?.files?.length" class="modal-content-flex-row mt-3">
              <div>
                <p class="p-0 m-0">Arquivo(s)</p>
                <p v-for="file in product.files" @click="openFile(file.url)" class="p-0 m-0 link">{{ file.original_name }}</p>
              </div>
          </div>
        </div>
        <template slot="footer">
        </template>
      </modal>
</template>
<script>
import { Modal } from "@/components";

export default {
  name: "modal-product-detail",
  components: {
    Modal
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    product: {
      type: Object,
      required: false,
      default: null
    },
  },
  data: () => ({
  }),
  methods: {
    openFile(url) {
      window.open(url, '_blank');
    }
  },
};
</script>
<style lang="scss">
@import "src/assets/sass/now-ui-dashboard/variables.scss";

.modal-dialog {
  max-width: 800px;
  width: 100%;
}

.modal-product-title {
  color: $primary-color;
}

.modal-content-flex-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: .5em 0;

  div {
    p:first-child {
      font-size: 14px;
      font-weight: bolder;
    }
    p.link {
      cursor: pointer;
      color: $primary-color;
      font-weight: bold;

      &:hover {
        color: $secondary-color;
      }
    }
  }
}
</style>
